import {createGlobalStyle} from "styled-components";
import bg_homepage from '../static/bg_homepage.png'
import bg_mobile from '../static/bg_mobile.png'

const GlobalStyle = createGlobalStyle`

  @font-face {
    font-family: Travels;
    src: url('/fonts/TT-Travels-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: Travels;
    src: url('/fonts/TT-Travels-Bold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'TT Travels';
    src: url('/fonts/TT-Travels-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'TT Travels';
    src: url('/fonts/TT-Travels-Bold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: Travels, Arial, Helvetica, sans-serif;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  a:link, a:visited { text-decoration: none; }
  a:hover { text-decoration: none; }

  aside, nav, footer, header, section, main { display: block; }
  ul, ul li { list-style: none; }
  img { vertical-align: top; }
  img, svg { max-width: 100%; }
  address { font-style: normal; }

  input, textarea, button, select {
    font-family: inherit;
    font-size: inherit;
    color: inherit;
    background-color: transparent;
  }
  input::-ms-clear { display: none; }
  button, input[type="submit"] {
    display: inline-block;
    box-shadow: none;
    background-color: transparent;
    background: none;
    cursor: pointer;
  }
  input:focus, input:active,
  button:focus, button:active { outline: none; }
  button::-moz-focus-inner { padding: 0; border: 0; }
  label { cursor: pointer; }
  legend { display: block; }

  body {
    background: url(${bg_homepage});
    background-repeat: no-repeat;
    background-size: cover;

    @media (max-width: 800px) {
      background: url(${bg_mobile});
      background-size: cover;
      background-repeat: no-repeat;
    }
  }

  html {
    font-size: 14px;

    @media(max-width: 1024px) { font-size: 10px; }
    @media (max-width: 768px) { font-size: 8px; }
  }
`

export default GlobalStyle